import { Badge, Card, Icon } from '@/components/ui';
import { formatMoney, formatPrice } from '@/features/billing/money';
import { cn } from '@/utils/cn';

import { studentPlanLines } from './plans';

/** One student plan: its price, what it grants, and the action for it. */
export function StudentPlanCard({ plan, saving, action }) {
  const current = plan.is_current;
  const paid = plan.price_cents > 0;

  return (
    <Card
      className={cn(
        'flex flex-col',
        current && 'border-brand-300 shadow-card',
        !current && paid && 'border-brand-100',
      )}
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="text-ink font-semibold">{plan.name}</h3>
        <div className="flex flex-wrap gap-1.5">
          {saving && (
            <Badge tone="success">Save {formatMoney(saving.cents, saving.currency)}</Badge>
          )}
          {current && <Badge tone="brand">Your plan</Badge>}
        </div>
      </div>

      <p className="text-ink mt-4 text-3xl font-semibold tracking-tight tabular-nums">
        {formatPrice(plan.price_cents, plan.currency, plan.interval)}
      </p>
      {plan.description && <p className="text-ink-muted mt-2 text-sm">{plan.description}</p>}

      <ul className="mt-5 space-y-2">
        {studentPlanLines(plan.student_entitlements).map((line) => (
          <li
            key={line.text}
            className={cn('flex gap-2 text-sm', line.included ? 'text-ink' : 'text-ink-muted')}
          >
            <Icon
              name={line.included ? 'check' : 'close'}
              size={16}
              className={cn('mt-0.5 shrink-0', line.included ? 'text-brand-600' : 'text-ink-muted')}
            />
            {line.text}
          </li>
        ))}
      </ul>

      <div className="mt-6 grow" />
      {action}
    </Card>
  );
}
